<script lang="ts">
      import { onMount, untrack } from 'svelte'
      import Play from '../ui/Play.svelte'
      import Pause from '../ui/Pause.svelte'
      import { Seek } from './ts/VideoElement.svelte'
      import Mute from '../ui/Mute.svelte'
      import Volume from '../ui/Volume.svelte'
      import Loading from '../ui/Loading.svelte'
      import { on } from 'svelte/events'

      let controlsTimeout: null | ReturnType<typeof setTimeout> = null

      function pad(s: string | number, length: number = 2, char: string = '0') {
            if (typeof s == 'number') s = String(s)
            while (s.length < length) {
                  s = char + '' + s
            }
            return s
      }

      function secondsToTime(s: number) {
            const _h = s / 3600
            const h = Math.floor(_h)
            const _m = (s % 3600) / 60
            const m = Math.floor(_m)
            const se = Math.floor((s % 3600) % 60)

            if (h == 0) return `${pad(m)}:${pad(se)}`
            return `${pad(h)}:${pad(m)}:${pad(se)}`
      }

      function showControl() {
            if (controlsTimeout) clearTimeout(controlsTimeout)
            mouseOver = true
            controlsTimeout = setTimeout(() => {
                  mouseOver = false
                  controlsTimeout = null
            }, 1750)
      }

      function hideControl() {
            mouseOver = false
      }

      async function handleControl(ev: MouseEvent | TouchEvent) {
            if (!element) return
            ev.stopPropagation()
            if (playing == false) {
                  element.play()
            } else {
                  element.pause()
            }
      }

      async function divertEvent(ev: Event) {
            //console.log('divert', ev.type)
            ev.stopPropagation()
      }

      async function handleMute(ev: Event) {
            if (!element) return
            ev.stopPropagation()
            element.muted = !stats.muted
            if (!element.paused) return
            await element.play()
            await element.pause()
      }

      async function handleFullscreen() {
            if (!element) return
            if (document.fullscreenElement) document.exitFullscreen()
            else element.parentElement?.requestFullscreen()
      }
      onMount(() => {
            const ctrl = new AbortController()

            controls.parentElement?.addEventListener('mousemove', showControl, { signal: ctrl.signal })
            controls.parentElement?.addEventListener('touchstart', showControl, { signal: ctrl.signal })
            controls.parentElement?.addEventListener('mouseleave', hideControl, { signal: ctrl.signal })
            controls.parentElement?.addEventListener('touchend', hideControl, { signal: ctrl.signal })

            on(panel, 'touchend', divertEvent, { signal: ctrl.signal })
            on(panel, 'touchstart', divertEvent, { signal: ctrl.signal })
            on(panel, 'mouseup', divertEvent, { signal: ctrl.signal })
            on(panel, 'mousedown', divertEvent, { signal: ctrl.signal })

            const seek = new Seek({ element: seekBubble, onmove: seekMove, onend: seekEnd })
            seek.init()

            return () => {
                  seek.destroy()
                  ctrl.abort()
            }
      })

      function seekMove(position) {
            _leftMove += position.tempPercX
      }

      function seekEnd(position) {
            _leftMove += position.tempPercX
            let diff = left + _leftMove
            if (diff > 100) diff = 100
            if (diff < 0) diff = 0
            const seeked = (diff * stats.length) / 100
            //console.log(seeked)

            if (element) element.currentTime = seeked
            _leftMove = 0
      }

      let { element = $bindable(), stats = {} }: { element: HTMLVideoElement; stats: any } = $props()

      let playing = $derived.by(() => {
            if (stats.playing === undefined) return false
            return stats.playing
      })

      let left = $derived.by(() => {
            if (stats.currentTime === undefined || stats.length === undefined || stats.currentTime < 0 || stats.length < 0) return 0
            return (stats.currentTime / stats.length) * 100
      })

      let length = $derived.by(() => {
            return stats.length
      })

      let time = $derived.by(() => {
            if (_leftMove) {
                  let diff = left + _leftMove
                  if (diff < 0) diff = 0
                  if (diff > 100) diff = 100
                  return (diff * length) / 100
            }
            return stats.currentTime
      })

      let _leftMove = $state(0)

      $effect(() => {
            let diff = left + _leftMove
            if (diff < 0) diff = 0
            if (diff > 100) diff = 100
            controls.style.setProperty('--LeftOffset', String(diff))
      })

      let visible = $derived.by(() => {
            if (mouseOver) return true
            if (playing) return false
            return true
      })

      async function info(ev) {
            //console.log(ev)
      }

      let mouseOver = $state(false)
      let controls: HTMLElement
      let seekBubble: HTMLElement

      let panel: HTMLElement
</script>

<!-- svelte-ignore a11y_no_static_element_interactions -->
<div
      style="--LeftOffset: 0"
      ondblclick={handleFullscreen}
      bind:this={controls}
      class=" controls {visible ? 'opacity-100' : 'opacity-0'} w-full h-full absolute top-0 left-0 z-[10] bg-[#46c34600] flex items-center justify-center">
      <button class="h-[6rem] bg-[#00000077] control-button rounded-full aspect-square active:scale-95" onmousedown={divertEvent} ontouchstart={divertEvent} ontouchend={handleControl} onmouseup={handleControl}>
            {#if !playing && stats.canPlayThrough}
                  <Play class="w-full h-full"></Play>
            {:else if !playing && !stats.canPlayThrough}
                  <Loading class="w-full h-full"></Loading>
            {:else}
                  <Pause class="w-full h-full"></Pause>
            {/if}
      </button>

      <div bind:this={panel} class="@container absolute control-panel w-full px-4 bottom-0 h-12 bg-[#00000055] flex justify-center items-center gap-2 {mouseOver ? 'opacity-100' : 'opacity-0'}">
            <div onmousedown={info} class="flex relative w-full seeker h-2 bg-gray-400 rounded-xl justify-center items-center">
                  <div bind:this={seekBubble} class="absolute seekBubble aspect-square h-6 md:h-4 rounded-full bg-gray-200" style="left: calc(var(--LeftOffset) * 1%)"></div>
            </div>

            <div class="hidden @[400px]:block text-nowrap text-gray-200">{secondsToTime(time)} / {secondsToTime(length)}</div>

            <button class="h-[3rem]" ontouchend={handleMute} onmouseup={handleMute}>
                  {#if stats.muted}
                        <Mute class="h-full"></Mute>
                  {:else}
                        <Volume></Volume>
                  {/if}
            </button>
      </div>
</div>

<style lang="postcss">
      .controls {
            transition:
                  opacity 0.6s ease-in-out,
                  transform 0.3s ease-in-out;
            transform-origin: center center;
      }
      .control-button {
            transition:
                  opacity 0.6s ease-in-out,
                  transform 0.3s ease-in-out;
            transform-origin: center center;
      }

      .control-panel {
            transition:
                  opacity 0.6s ease-in-out,
                  transform 0.3s ease-in-out;
      }
      .seekBubble {
            transform: translateX(-50%);
      }

      .seeker {
            /*width: calc(100% - 1.4rem);*/
      }
</style>
